/**
 * How the backend validates the order minimum. Mirrors the Odoo setting
 * `sales_smc.minimum_spend_validation_method` (DEV-8732).
 *
 * - `before_discounts`: validate against the pre-discount subtotal.
 * - `after_discounts`: validate against the subtotal the customer actually pays.
 *
 * When the backend omits the field the frontend falls back to `after_discounts`.
 */
export const MINIMUM_SPEND_VALIDATION_METHOD = {
  before_discounts: 'before_discounts',
  after_discounts: 'after_discounts',
} as const;

export type MinimumSpendValidationMethod =
  (typeof MINIMUM_SPEND_VALIDATION_METHOD)[keyof typeof MINIMUM_SPEND_VALIDATION_METHOD];
